import React from "react"
import defaultSurveyConfig from "../../pages/RMO/components/cancerTemplateForm/template"
import SurveyComponent from "../../pages/RMO/components/cancerTemplate/Template"
import "./JSONRenderer.scss"
import PatientDetailsPrintHeader from "components/CommonPrintComponent/PatientDetailsPrintHeader"
import CommonPrintComponent from "components/CommonPrintComponent/CommonPrintComponent"

export interface ISurveyProps {
  json: any,
  data: any,
  handleCompletion: any,
  printRef?: any,
  printJson?: any,
  printData?: any,
  updateFlag?: any,
  patientData?: any,
  showPatientDetails?: any,
  origin: any,
  smartSummaryData?: any,
  appointmentDate?: any,
}

const JSONRenderer: React.FunctionComponent<ISurveyProps> = (props) => {
  const { json, data, handleCompletion, printRef, printJson, printData, updateFlag, patientData, showPatientDetails, origin, smartSummaryData, appointmentDate } = props

  return (
    <div className="survey-renderer-container">
      <div>
        <SurveyComponent
          css={defaultSurveyConfig.defaultSurveyCSS}
          data={data}
          json={json}
          updateFlag={updateFlag}
          patientInfo={patientData?.patientInfo}
          onComplete={(survey: any) => {
            const data = survey.data
            handleCompletion(data)
            /** Save to a database */
            /** Add to a spreadsheet, etc.... */
          }}
          hideDot={true}
        />
      </div>
      <div
        className="print-component"
        ref={printRef}
      >
        {
          showPatientDetails && (
            patientData && Object.keys(patientData)?.length > 0
            && (
              <PatientDetailsPrintHeader
                patientData={patientData}
                origin={origin}
                smartSummaryData={smartSummaryData}
                appointmentDate={appointmentDate}
              />
            )
          )
        }
        <CommonPrintComponent
          data={printData}
          json={printJson}
          hideDot={true}
        />
      </div>
    </div>
  )
}

export default JSONRenderer
